<template>
<div>
    <md-dialog-content>
        <p>Create Your Starting Layers</p>
        <md-list>
            <layer-lite v-for="layer in project.layers"
                :key="layer.id"
                :layer="layer" 
                @deleteLayer="deleteLayer">
            </layer-lite>
        </md-list>
        <layer-new :project="project" @addLayer="addLayer" />
    </md-dialog-content>
</div>
</template>

<script>
import LayersLayerLite from '@/components/layers/layer-lite';
import LayersLayerNew from '@/components/layers/layer-new';

const Layers = {
    name: 'layers',
    props: ['project'],
    methods: {
        // Cryptographically secure random number generator for browser
        // Uses Web Crypto API instead of Math.random() for better security
        getSecureRandomInt(max) {
            const array = new Uint32Array(1);
            window.crypto.getRandomValues(array);
            return array[0] % max;
        },
        addLayer(layer) {
            // Cryptographically secure ID generation using Web Crypto API
            // Ensures uniqueness and prevents predictable IDs
            layer.id = this.getSecureRandomInt(1000000);
            this.project.layers.unshift(layer);
        },
        deleteLayer(layer) {
            const index = this.project.layers.findIndex((l) => {
                return l.title === layer.title;
            });
            this.project.layers.splice(index, 1);
        }
    },
    components: {
        'layer-lite': LayersLayerLite,
        'layer-new': LayersLayerNew
    }
};
export default Layers;
</script>


// WEBPACK FOOTER //
// layers.vue?1df58cb4